module.exports = __webpack_public_path__ + "static/img/bg_01.ef5af86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_01.jpg
// module id = E9zq
// module chunks = 1